export default "__VITE_ASSET__CwmX2FTY__"